import { normalizeAnnotation } from 'chessboard/model/annotation/normalize-annotation';
import type { ContextMenu } from 'components/move-list/components/context-menu/config/types';
import type { Store, StoreActions } from 'components/move-list/store/types';
import { CONTEXT_MENU_ACTION_NAMES } from '../config/context-menu-action-names';

/**
 * Create AddAnnotation action
 */
export function createAddAnnotation(
  _store: Store,
  _storeActions: StoreActions,
): ContextMenu.Action {
  return {
    getDisplayName: () => '', // not displayed in the menu
    action: CONTEXT_MENU_ACTION_NAMES.AddAnnotation,
    isVisible,
    handler,
  };

  /**
   * never visible in the menu
   */
  function isVisible() {
    return false;
  }

  /**
   * handler to add annotation
   */
  function handler({ node, game }, payload?: { data: { annotation: string } }): void {
    if (!payload?.data?.annotation) {
      return;
    }

    const existingAnnotation = normalizeAnnotation(node.annotation);
    const isDifferentAnnotation = payload.data.annotation !== existingAnnotation;

    const value = isDifferentAnnotation ? payload.data.annotation : '';

    game.updateNode(node.ids, { annotation: value });
  }
}
